import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaAditivosComponent } from "./aba-aditivos.component";

@NgModule({
    declarations: [AbaAditivosComponent],
    imports:[SharedModule],
    exports:[AbaAditivosComponent]
})
export class AbaAditivosModule {}